import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";

export const getProfessionalsAPI = createAsyncThunk(
    "getProfessionalsAPI",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getAllProfessionals(payload));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const getSingleProfessionalAPI = createAsyncThunk(
    "getSingleProfessionalAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getSingleProfessional(id));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const UpdateProfessionalStatusAPI = createAsyncThunk(
    "UpdateProfessionalStatusAPI",
    async (data, { rejectWithValue }) => {
        const id = data?.id
        const status = data?.status
        try {
            const response = await api.post(endpoints.updateProfessionalStatus(id, status));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
    professionals: [],
    singleProfessional: "",
    pagination: {
        current_page: 1,
        total_pages: 1,
    }
}

const superAdminProfessionalSlice = createSlice({
    initialState,
    name: "superAdminProfessionalSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProfessionalsAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getProfessionalsAPI.fulfilled, (state, action) => {
            state.professionals = action.payload.data.data.data;
            state.pagination = {
                current_page: action.payload.data.data.current_page,
                total_pages: action.payload.data.data.last_page,
            };
            state.loading = false;
        });

        builder.addCase(getProfessionalsAPI.rejected, (state, action) => {
            state.loading = false;
        });

        // GET SINGLE PROFESSIONAL

        builder.addCase(getSingleProfessionalAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getSingleProfessionalAPI.fulfilled, (state, action) => {
            state.singleProfessional = action.payload.data.data;
            state.loading = false;
        });

        builder.addCase(getSingleProfessionalAPI.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export const { } = superAdminProfessionalSlice.actions
export default superAdminProfessionalSlice.reducer